import script from "./OfferNew.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferNew.vue?vue&type=script&setup=true&lang=js"

import "./OfferNew.vue?vue&type=style&index=0&id=4aeff2a6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aeff2a6"]])

export default __exports__